/**
 * Valores monetários trafegam e são armazenados SEMPRE em centavos inteiros.
 * Nunca use number com casas decimais para dinheiro.
 */
export type Cents = number;

const brl = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });

export function formatBRL(cents: Cents): string {
  if (!Number.isSafeInteger(cents)) throw new Error('Valor monetário deve ser inteiro em centavos');
  return brl.format(cents / 100);
}

/** Converte "12,50", "1.234,56" ou "12.5" em centavos. Retorna null se inválido. */
export function parseBRL(input: string): Cents | null {
  const s = input.trim().replace(/^R\$\s*/, '');
  if (!s) return null;
  let normalized: string;
  if (s.includes(',')) normalized = s.replace(/\./g, '').replace(',', '.');
  else normalized = s;
  if (!/^\d+(\.\d{1,2})?$/.test(normalized)) return null;
  const [int, frac = ''] = normalized.split('.');
  return Number(int) * 100 + Number(frac.padEnd(2, '0'));
}
